import { useState } from 'react';
import { toast } from 'react-toastify';
import useUser from '../global/useUser';
import { LoadedUser } from '../../interfaces';
import { updateBusinessWebRedesign } from '../../services/business';
import { canIndependentManageShop } from '../../helpers/businesses';
import { isUserAdminOrManager } from '../../utils/global/helper';

function useBusinessWebRedesignToggle() {
  const { user } = useUser<LoadedUser>();
  const [isSaving, setIsSaving] = useState(false);

  const canManage =
    !!user && (isUserAdminOrManager(user) || canIndependentManageShop(user));
  const businessId = user?.business?.id;

  const setEnabled = async (enabled: boolean, reason?: string) => {
    if (!businessId) return false;
    setIsSaving(true);
    try {
      await updateBusinessWebRedesign(businessId, enabled, reason);
      window.location.reload();
      return true;
    } catch {
      toast.error('Failed to update design preference');
      setIsSaving(false);
      return false;
    }
  };

  return { canManage, isSaving, setEnabled };
}

export default useBusinessWebRedesignToggle;
